// Model.js
// -----------------------
// @module Case
define("NVT.NuSmart_Sponser_Profile.NusmartSponserProfileModule.SS2Model", ["Backbone", "Utils"], function(
    Backbone,
    Utils
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "Modules/NusmartSponserProfileModule/SuiteScript2/NusmartSponserProfileModule.Service.ss"
            ),
            true
        )
});
});
